// Copyright (c) 2016 Deere & Company

import actions from '../../actions-list';

export const updateMaintenancePlanSelectedDealers = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.UPDATE_MAINTENANCE_PLAN_DEALER_CRITERIA
});

export const updateMaintenancePlanSelectAllDealers = dealers => ({
    dealers,
    type: actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_DEALERS_CRITERIA
});

export const updateMaintenancePlanAttributesCriteria = (attribute, value) => ({
    attribute,
    type: actions.UPDATE_MAINTENANCE_PLAN_ATTRIBUTES_CRITERIA,
    value
});

export const updateMaintenancePlanPlanStartDate = planStartDateRange => ({
    planStartDateRange,
    type: actions.UPDATE_MAINTENANCE_PLAN_PLAN_START_DATE_CRITERIA
});

export const updateMaintenancePlanPlanEndDate = planEndDateRange => ({
    planEndDateRange,
    type: actions.UPDATE_MAINTENANCE_PLAN_PLAN_END_DATE_CRITERIA
});

export const updateMaintenancePlanServiceIntervalBeginDate = serviceIntervalBeginDateRange => ({
    serviceIntervalBeginDateRange,
    type: actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_BEGIN_DATE_CRITERIA
});

export const updateMaintenancePlanServiceIntervalEndDate = serviceIntervalEndDateRange => ({
    serviceIntervalEndDateRange,
    type: actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_END_DATE_CRITERIA
});

export const updateMaintenancePlanSelectedServiceIntervalStatuses = (status, isSelected) => ({
    isSelected,
    status,
    type: actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_STATUSES_CRITERIA
});

export const updateMaintenancePlanSelectAllServiceIntervalStatuses = () => ({
    type: actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_SERVICE_INTERVAL_STATUSES_CRITERIA
});

export const updateAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_DEALERS_CRITERIA_ON_LOAD
});

export const resetSearchCriteria = (dealers, criteria) =>
    dispatch => {

        dispatch({
            type: actions.RESET_MAINTENANCE_PLAN_REPORT_SEARCH_CRITERIA
        });

        dispatch({
            data: criteria.serviceIntervalStatuses.allowed,
            type: actions.UPDATE_MAINTENANCE_PLAN_SERVICE_INTERVAL_STATUSES_SUCCESS
        });

        dispatch({
            dealers,
            type: actions.UPDATE_MAINTENANCE_PLAN_SELECT_ALL_DEALERS_CRITERIA_ON_LOAD
        });

        dispatch({
            data: false,
            type: actions.UPDATE_CRITERIA_VALIDITY
        });

    };



// WEBPACK FOOTER //
// ./src/reports/maintenance-plan/action-creators/criteria.js